import { RADashboardLayout } from "@/interfaces/raDashboard.interface"
import { RADashboardPortfolioType } from "../asset-enums"
import { RADashboardCardId } from "../cards-enums"
import { RADashboardTabId } from "../tab-enums"

// Default layout for a factor attribution dashboard: the return charts, daily return, and factor
// attribution cards on Overview.
export const DefaultAttributionDashboardLayout: RADashboardLayout = {
  "suggestedPortfolioType": [RADashboardPortfolioType.MultiAsset],
  "tabsOrder": [RADashboardTabId.Overview, RADashboardTabId.Holdings],
  "initialTab": RADashboardTabId.Overview,
  "tabLayouts": {
    [RADashboardTabId.Overview]: {
      "cardsOrder": [
        RADashboardCardId.Chart_PortfolioReturn,
        RADashboardCardId.Chart_BenchmarkReturn,
        RADashboardCardId.Chart_ActiveReturn,
        RADashboardCardId.Chart_DailyReturn,
        RADashboardCardId.Chart_FactorAttribution,
      ],
    },
    [RADashboardTabId.Holdings]: {
      "cardsOrder": [
        RADashboardCardId.Table_Holdings,
        RADashboardCardId.Table_HoldingsTopBottom,
        RADashboardCardId.Chart_HoldingsBubble,
      ],
    },
  },
  "tabSettings": {
    [RADashboardTabId.Overview]: {
      "label": "Portfolio"
    },
    [RADashboardTabId.Holdings]: {
      "label": "Holdings"
    },
  },
  "cardSettings": {
    [RADashboardCardId.Chart_PortfolioReturn]: { size: "S" },
    [RADashboardCardId.Chart_BenchmarkReturn]: { size: "S" },
    [RADashboardCardId.Chart_ActiveReturn]: { size: "S" },
    [RADashboardCardId.Chart_DailyReturn]: { size: "L" },
    [RADashboardCardId.Chart_FactorAttribution]: { size: "L" },
    [RADashboardCardId.Table_Holdings]: { size: "L" },
    [RADashboardCardId.Table_HoldingsTopBottom]: { size: "S" },
    [RADashboardCardId.Chart_HoldingsBubble]: { size: "S" },
  }
}

export default DefaultAttributionDashboardLayout;
